<template>
  <v-data-table
    :custom-filter="filterOverAllProperty"
    :headers="headers"
    :items="bookings"
    :loading="$store.getters['Ajax/loading'] ? 'accent' : false"
    :sort-by.sync="pagination.sortBy"
    :sort-desc.sync="pagination.descending"
    :search="search"
    :items-per-page="5"
  >
    <template #item="props">
      <tr>
        <td class="">{{ formatDateView(props.item.creation_date) }}</td>
        <td>
          {{ props.item.reservation_number }}

          <v-chip label outlined small style="color: #FFE3F3; background-color: #ff99d0 !important;" v-if="props.item.is_cancelled === 1"
            >{{ $t("booking.canceled") }}
          </v-chip>
          <assigned-delegations-chip :delegations="props.item.delegations" />
        </td>
        <td class="py-2">
          <template
            v-if="
              props.item.hotelAttributes.vendor != null || props.item.hotelAttributes.address != null || props.item.hotelAttributes.hotel_phone_number !== null
            "
          >
            <span class="accent--text font-weight-bold">{{ props.item.hotelAttributes.vendor }}</span
            ><br /><span class="grey--text">{{ props.item.hotelAttributes.address }}</span> <br />
            <span class="grey--text" style="font-weight: bold" v-if="props.item.hotelAttributes.hotel_phone_number !== null"
              >{{ $t("global.phoneNumber") }}: {{ props.item.hotelAttributes.hotel_phone_number }}</span
            >
          </template>
          <template v-else>
            <span class="grey--text">{{ $t("global.noData") }}</span>
          </template>
        </td>
        <td class="font-weight-bold">
          <template v-if="props.item.hotelAttributes.start_date != null || props.item.hotelAttributes.end_date != null">
            {{ formatDateView(props.item.hotelAttributes.start_date) }}<br />{{ formatDateView(props.item.hotelAttributes.end_date) }}
          </template>
          <template v-else>{{ $t("global.noData") }}</template>
        </td>
        <td class="">
          <!-- eslint-disable-next-line -->
          <span v-for="passenger of props.item.passengers" style="text-transform: capitalize"> {{ passenger }} <br /> </span>
        </td>
        <td class="datatable-total-amount">
          <template v-if="props.item.invoice_gross_value !== null">{{ props.item.invoice_gross_value }} {{ props.item.invoice_currency }}</template>
          <template v-else-if="props.item.total_amount !== null">{{ props.item.total_amount }} PLN</template>
        </td>
        <td v-if="$store.state.Auth.isWnt === false">{{ props.item.hotelAttributes.primitive_exchange_rate }}</td>
        <td class="text-center text-no-wrap">
          <slot name="action-column" v-bind:booking="props.item">
            <v-tooltip bottom>
              {{ $t("global.goToDetails") }}
              <template #activator="{on}">
                <v-btn :to="'/booking/other/detail/' + props.item.id" class="mx-0" icon v-on="on">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip bottom>
              {{ $t("global.downloadFile") }}
              <template #activator="{on}">
                <v-btn :disabled="$store.getters['Ajax/loading']" @click="downloadAttachment(props.item.id)" class="mx-0" icon v-on="on">
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </slot>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import formatDateView from "../../repository/fotmatDateView";
import filterOverAllProperty from "../../repository/filterOverAllProperty";
import AssignedDelegationsChip from "./AssignedDelegationsChip";
import downloadFile from "../../repository/downloadFile";

export default {
  name: "BookingHotelDataTable",
  components: { AssignedDelegationsChip },
  props: {
    search: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    bookings: [],
    pagination: {
      sortBy: "creation_date",
      descending: true
    }
  }),
  computed: {
    isWNBUser() {
      return this.$store.getters["isWnbUser"];
    },
    headers() {
      let array = [];
      array.push({ text: this.$t("booking.dateShort"), value: "creation_date" });
      array.push({ text: this.$t("booking.numberShort"), value: "reservation_number" });
      array.push({ text: this.$t("booking.hotel.vendor"), value: "hotelAttributes.vendor" });
      array.push({ text: this.$t("booking.hotel.accommodationDates"), value: "hotelAttributes.start_date" });
      array.push({ text: this.$t("booking.passengers"), value: "passengers" });
      array.push({ text: this.$t("booking.price"), value: "total_amount" });
      if (this.$store.state.Auth.isWnt === false) {
        array.push({ text: this.$t("booking.hotel.primitiveExchangeRate"), value: "hotelAttributes.primitive_exchange_rate" });
      }
      array.push({ text: "", value: "actions", sortable: false });
      return array;
    }
  },
  methods: {
    formatDateView: formatDateView,
    filterOverAllProperty: filterOverAllProperty,
    downloadAttachment(id) {
      downloadFile("booking/get-booking-file?bookingId=" + id);
    }
  },
  created() {
    this.axios.get("booking/get-hotel").then(resp => {
      this.bookings = resp.data;
    });
  }
};
</script>

<style scoped></style>
